<div layout-horizontal layout-align-items-center class="input-with-domain">
  <span margin-right-small-xx>{{ prefix() }}</span>
  <rt-input
    #inputComponent
    [placeholder]="'rti.common.integration.subdomain_placeholder' | translate"
    (valueChange)="handleChange($event)"
    text-primary
  />
  <span margin-left-small-xx>{{ suffix() }}</span>
</div>
